import classnames from "classnames";

import { Component, Fragment } from '@wordpress/element';
import { MediaUpload } from "@wordpress/block-editor";

import { MediaTypeOptions } from "~buildable/utils/media-enums";

class WpMediaPreview extends Component {
  constructor() {
    super(...arguments);

    this.renderPreview = this.renderPreview.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.setMediaPreviewUrl = this.setMediaPreviewUrl.bind(this);
  }

  onKeyDown(e, obj) {
    if (e.code === "Enter") {
      this.onPreviewClick(obj);
    }
  }

  setMediaPreviewUrl(media) {
    if (media && media.type === "video") {
      /** @var videoPlaceholderUrl string */
      return videoPlaceholderUrl;
    } else if (media && media.url) {
      return media.url;
    } else {
      /** @var imagePlaceholderUrl string */
      return imagePlaceholderUrl;
    }
  }

  renderPreview(obj) {
    const {
      media = {},
      displayAsImg,
      gallery
    } = this.props;

    const onRemove = (e) => {
      e.stopPropagation();
      this.props.onRemove();
    }

    const removeMediaFromArray = (e, index) => {
      e.stopPropagation();
      if (Array.isArray(media)) {
        media.splice(index, 1);

        if (typeof this.props.onUpdateArray === "function") {
          this.props.onUpdateArray(media.slice());
        }
      }
    }

    let shouldShowRemoveButton = false;
    let shouldShowMultiple = false;
    let previewUrl;
    if (Array.isArray(media) && media.length > 0) {
      if (media.length === 1) {
        previewUrl = this.setMediaPreviewUrl(media[0]);

        shouldShowRemoveButton = !!media[0] && typeof media[0].id !== "undefined";
      } else if (media.length > 1) {
        shouldShowMultiple = true;
        previewUrl = media.map(m => this.setMediaPreviewUrl(m));
      }
    } else {
      previewUrl = this.setMediaPreviewUrl(media);
      shouldShowRemoveButton = !!media && typeof media.id !== "undefined";
    }

    const mediaUploadTriggerStyle = { backgroundImage: `url('${imagePlaceholderUrl}')` };

    const classes = classnames(["wp-media-preview"], {
      "display-as-img": displayAsImg,
      "multiple": shouldShowMultiple
    });

    const style = !displayAsImg ? {
      backgroundImage: `url(${previewUrl})`
    } : null;

    return (
      <Fragment>
        <div
          className={ classes }
          onClick={ () => !shouldShowMultiple ? obj.open() : null }
          onKeyDown={ e => this.onKeyDown(e, obj) }
          role="button"
          style={ style }
        >
          { shouldShowMultiple && (
            <div className="multiple-container">
              { media.map((item, i) => {
                const style = { backgroundImage: `url('${previewUrl[i]}')`};
                const removeIcon = !gallery
                  ? (
                    <a className="remove-icon-container" onClick={ e => removeMediaFromArray(e, i) }>
                      <i className="far fa-times" />
                    </a>
                  )
                  : null;

                return (
                  <div key={ `preview_${i}` } className="preview-block" style={ style }>
                    <a className="remove-icon-container" onClick={ e => removeMediaFromArray(e, i) }>
                      <i className="far fa-times" />
                    </a>
                  </div>
                );
              }) }
              <div
                className="media-upload-trigger"
                onClick={ () => obj.open() }
                style={ mediaUploadTriggerStyle }
              />
            </div>
          ) }
          { !shouldShowMultiple && (
            <Fragment>
              { displayAsImg &&
              <img src={ previewUrl } />
              }
              { shouldShowRemoveButton &&
              <a className="remove" onClick={ onRemove }>Remove</a>
              }
            </Fragment>
          ) }
        </div>
      </Fragment>
    )
  }

  render() {
    const {
      media = {},
      onChange,
      allowedTypes = [MediaTypeOptions.IMAGE],
      allowMultiple,
      gallery
    } = this.props;

    let mediaValue;
    if (media) {
      if (!Array.isArray(media)) {
        mediaValue = media.id;
      } else {
        mediaValue = media.map(m => m.id);
      }
    }

    return (
      <MediaUpload
        allowedTypes={ allowedTypes }
        onSelect={ onChange }
        value={ mediaValue }
        render={ this.renderPreview }
        multiple={ allowMultiple || gallery }
        gallery={ gallery }
      />
    )
  }
}

export default WpMediaPreview;
